import React from 'react';
import { Select } from 'antd';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../../../../../../../../store';
import mask from 'utils/mask';

interface Props {
  setSelectCd: React.Dispatch<React.SetStateAction<number>>;
  setDisabledButton: React.Dispatch<React.SetStateAction<boolean>>;
  setShowhorarios: React.Dispatch<React.SetStateAction<boolean>>;
  setShowAlert: React.Dispatch<React.SetStateAction<boolean>>;
  cddAgendamento: string;
}
const SelectCd: React.FC<Props> = ({
  setSelectCd,
  setDisabledButton,
  setShowhorarios,
  setShowAlert,
  cddAgendamento,
}) => {
  const { Option } = Select;

  const { user } = useSelector((state: ApplicationState) => state.auth);
  const perfilMaster = useSelector((state: ApplicationState) => state.auth.user?.master);

  const handleSelect = (value: string, e: any) => {
    if (e.key) {
      setSelectCd(+e.key);
      setDisabledButton(true);
      setShowhorarios(true);
      setShowAlert(true);
    }
  };

  return (
    <div>
      <Select
        style={{ width: '100%', textAlign: 'center' }}
        filterOption={(inputValue, option) =>
          option!.value?.toUpperCase().indexOf(inputValue?.toUpperCase()) !== -1
        }
        onChange={handleSelect}
        placeholder={mask('camelCase', cddAgendamento)}
      >
        {user?.centroDistribuicao?.map((item) => {
          if (!perfilMaster) {
            return (
              item.codCdd !== 999 && (
                <Option key={item.codCdd} value={item.nomeFantasia}>
                  <p>{mask('camelCase', item.nomeFantasia)}</p>
                </Option>
              )
            );
          } else {
            return (
              <Option key={item.codCdd} value={item.nomeFantasia}>
                <p>{mask('camelCase', item.nomeFantasia)}</p>
              </Option>
            );
          }
        })}
      </Select>
    </div>
  );
};

export default SelectCd;
